import styles from "./style.module.scss";
import TopImage from "src/assets/facility_top_image.jpg";

export const TopSection = () => {
  return (
    <section className={styles.container}>
      <div className={styles.backgroundImg}>
        <img src={TopImage} alt="Facility" />
        <div className={styles.titleBox}>
          <h1>Facility Overview</h1>
          <p>施設概要</p>
        </div>
      </div>
    </section>
  );
};
